import "./index.css"
import { setCategories, getCategories } from "@wordpress/blocks"

// Register custom block category
setCategories([
  ...getCategories().filter(({ slug }) => slug !== 'puroclean'),
  {
    slug: 'puroclean',
    title: 'PuroClean Blocks',
    icon: 'shield-alt'
  }
])

// Import all blocks
import './blocks/hero-section'
import './blocks/simple-hero'
import './blocks/emergency-response'
import './blocks/services-overview'
import './blocks/emergency-banner'
import './blocks/emergency-banner-partnerships'
import './blocks/veterans-section'
import './blocks/who-we-serve'
import './blocks/trust-factors'
import './blocks/learn-more'
import './blocks/success-stories'
import './blocks/community-commitment'
import './blocks/service-explanation'
import './blocks/what-to-expect'
import './blocks/testimonials'
import './blocks/cards-group'
import './blocks/card-content'
import './blocks/urgent-damage'
import './blocks/blog-listing'
import './blocks/text-banner'
import './blocks/faq-section'
import './blocks/before-after'
import './blocks/image-slider'
import './blocks/card'
import './blocks/icon-hero'
import './blocks/white-papers'
import './blocks/section'
import './blocks/flexible-columns'
import './blocks/icon-and-title'
import './blocks/custom-banner'
import './blocks/big-card'
import './blocks/content-banner'
import './blocks/tabs'
import './blocks/tab-item'
import './blocks/hero-slides'
import './blocks/weather-section'
import './blocks/disaster-related-posts'

// Import components
import './components/ArrowLinkBlock'
import './components/ArrowLinkFormat'

// Keep any standalone scripts that aren't blocks
import React from "react"
import ReactDOM from "react-dom/client"